import React from "react";
import { useT } from "../i18n/I18nProvider";

const G1 = "https://customer-assets.emergentagent.com/job_0fd4690a-f926-4f16-a271-7c74d84a7281/artifacts/wdq07vza_image.png";
const G2 = "https://customer-assets.emergentagent.com/job_0fd4690a-f926-4f16-a271-7c74d84a7281/artifacts/2vx00vzk_image.png";
const G3 = "https://customer-assets.emergentagent.com/job_0fd4690a-f926-4f16-a271-7c74d84a7281/artifacts/epnk7n1m_image.png";
const G4 = "https://customer-assets.emergentagent.com/job_colorful-imports/artifacts/na3rqnnm_image.png";

export default function Gallery() {
  const { t } = useT();
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="py-20 md:py-28 bg-[#f5efde] relative"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-12">
          <div>
            <div className="text-[12px] uppercase tracking-[0.22em] text-[#b8420f] font-bold mb-3">
              {t("gallery.eyebrow")}
            </div>
            <h2 className="font-display font-black text-stone-900 text-[38px] md:text-[52px] leading-[1.05] tracking-tight">
              {t("gallery.h_a")}{" "}
              <span className="font-script text-[#14532d] text-[60px] md:text-[80px] leading-none">
                {t("gallery.h_b")}
              </span>{" "}
              {t("gallery.h_c")}
            </h2>
          </div>
          <a
            href="https://www.facebook.com/p/El-Sol-Mexican-Imports-100063473202830/"
            target="_blank"
            rel="noreferrer"
            data-testid="gallery-fb-link"
            className="inline-flex items-center gap-2 text-[14px] font-bold text-[#14532d] hover:text-[#b8420f] transition-colors"
          >
            {t("gallery.fb_link")}
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M7 17L17 7M17 7H8M17 7v9"/></svg>
          </a>
        </div>

        <div className="grid grid-cols-12 grid-rows-2 gap-4 md:gap-5 h-[460px] md:h-[640px]">
          <figure data-testid="gallery-img-1" className="lift col-span-7 row-span-2 relative rounded-[28px] overflow-hidden bg-stone-200">
            <img src={G3} alt={t("gallery.cap_garden")} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
            <figcaption className="absolute bottom-4 left-4 bg-white/95 backdrop-blur px-3 py-1.5 rounded-full text-[12px] font-bold text-stone-900">
              {t("gallery.cap_garden")}
            </figcaption>
          </figure>

          <figure data-testid="gallery-img-2" className="lift col-span-5 row-span-1 relative rounded-tr-[44px] rounded-bl-3xl rounded-tl-3xl rounded-br-3xl overflow-hidden bg-stone-200">
            <img src={G2} alt={t("gallery.cap_talavera")} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
            <figcaption className="absolute bottom-3 left-3 bg-[#14532d] text-white px-3 py-1.5 rounded-full text-[11px] font-bold uppercase tracking-wide">
              {t("gallery.cap_talavera")}
            </figcaption>
          </figure>

          <figure data-testid="gallery-img-3" className="lift col-span-5 row-span-1 relative rounded-3xl overflow-hidden bg-stone-200">
            <img src={G1} alt={t("gallery.cap_metal")} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
            <figcaption className="absolute bottom-3 left-3 bg-[#b8420f] text-white px-3 py-1.5 rounded-full text-[11px] font-bold uppercase tracking-wide">
              {t("gallery.cap_metal")}
            </figcaption>
          </figure>
        </div>

        <div className="mt-5 md:mt-6">
          <figure data-testid="gallery-img-4" className="lift relative rounded-[28px] overflow-hidden h-[260px] md:h-[340px]">
            <img src={G4} alt={t("gallery.pasale_sub")} className="absolute inset-0 w-full h-full object-cover object-center" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-stone-900/55 via-stone-900/10 to-transparent" />
            <figcaption className="absolute bottom-5 left-5 right-5 text-white">
              <div className="font-script text-3xl text-orange-200 leading-none">{t("gallery.pasale")}</div>
              <div className="text-[14px] font-semibold mt-1">{t("gallery.pasale_sub")}</div>
            </figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
}
